import React, { useState, useEffect } from 'react';
import { CardContent, Typography, Box, Grid, Drawer, Avatar, Button, Divider, Modal } from '@mui/material';
import CardData from "../CardData/CardData";
import EditIcon from '@mui/icons-material/ModeEdit';
import { IAccountingInformation } from "../../utils/account.types";
import DialogAccountingForm from '../DialogAccountingForm/DialogAccountingForm';
import {
    useAppSelector,
} from "../../store/hooks";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';

export default function LegalInformation() {
    const [accountingInfo, setAccountingInfo] = useState<IAccountingInformation>();
    const [open, setOpen] = useState(false);
    // const [fetchData, setFetchData] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('')

    const accountDetails = useAppSelector(state => state.account.accountDetails);
    const cardClicked = () => {
        setOpen(true);
    }

    const getData = (data: any): IAccountingInformation => {

        const { gPayPhone, gPayPhoneVerifiedFlag, upiId } = data;
        return {
            'upiId': { value: upiId, title: 'UPI ID' },
            'gpayNumber': { value: gPayPhone, title: 'GPay Number' },
            'gpayVerified': { value: gPayPhoneVerifiedFlag ? 'Yes' : 'No', title: 'GPay Verified' },
        };
    };
    const closeDialog = (isSaved: boolean) => {
        setOpen(false);

        if (isSaved) {
            // setFetchData(Math.random().toString());
        }
    }
    useEffect(() => {
        let legalInfoAvaliable = true;
        const fetchLegalInfo = async () => {
            try {
                if (legalInfoAvaliable) {
                    Object.keys(accountDetails).length && setAccountingInfo(getData(accountDetails));
                    setQrCodeUrl(accountDetails.qrCodeUrl)
                }
            } catch (error: any) {
                console.error('Accounting info catch called')
            }
        };
        fetchLegalInfo();
        return () => {
            legalInfoAvaliable = false;
        };
    }, [accountDetails]);
    const legalData = () => {
        const data = [];
        for (const key in accountingInfo) {
            data.push(<CardData key={key} card={accountingInfo[key as keyof IAccountingInformation]} />)
        }
        return data;
    }
    return (
        <>
            <div className={'c-card2'} style={{ padding: 12, paddingTop: 12, marginTop: 15 }}>
                <Button
                    size='small'
                    variant="contained"
                    style={{
                        float: "right",
                        color: '#488dff',
                        backgroundColor: '#fff',
                        border: '0.5px solid #488dff',
                        height: 25, borderRadius: 7
                    }}
                    onClick={cardClicked}
                >Change
                </Button>
                <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginBottom: 10 }}>Payment</h5>
                <Divider sx={{ mt: 0.5, mb: 1 }} />
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{accountingInfo?.upiId.title}</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountingInfo?.upiId.value || '-'}</h5>
                    </Grid>

                    <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{accountingInfo?.gpayNumber.title}</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountingInfo?.gpayNumber.value || '-'}</h5>
                    </Grid>

                    <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{accountingInfo?.gpayVerified?.title}</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{accountingInfo?.gpayVerified?.value || '-'}</h5>
                    </Grid>
                </Grid>
                <Modal
                    open={open}
                    onClose={(event: any, reason: any) => {
                        if (reason !== 'backdropClick') {
                            setOpen(true)
                        }
                    }}
                >
                    {<DialogAccountingForm open={open} data={accountDetails} onClose={closeDialog}></ DialogAccountingForm>}
                </Modal>
            </div>
            {/* {qrCodeUrl && <Grid item xs={12}>
                            <Avatar
                                alt={'BI'}
                                imgProps={{ "referrerPolicy": 'no-referrer' }}
                                src={`${qrCodeUrl}`}
                                variant='square'
                                style={{ margin:'auto', width: '130px', height: '130px', objectFit: 'contain' }}
                            />
                        </Grid>} */}

        </>
    );
};
